// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  environmentLabel: 'prod',
  environmentLabelVisible: false,
  idleTimeoutInMinutes: 12 * 60,
  agGridLicenseKey: '',
  okta: true,
  oktaDomain: 'https://login.tecalliance.net',
  oktaClientId: '0oaqblos9rukIsTwb417',

  services: {
    baseUri: 'https://preview.vdp.tecalliance.net',
    vdpApi: 'https://api.preview.vdp.tecalliance.net/api',
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
